import React from "react";
import { NETWORK_URL } from "@/lib/networkData";

// Slim, centered top line on the landing hero: the network wordmark linking to the network site.
export const NetworkContactBar = () => (
  <div data-testid="network-contact-bar" className="w-full max-w-5xl mx-auto mb-12 flex justify-center">
    <a
      data-testid="network-cta-top"
      href={NETWORK_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="text-center text-xs sm:text-sm tracking-[0.22em] uppercase text-muted-foreground hover:text-foreground transition-colors"
    >
      Rexxpons Network <span className="text-primary/80">by</span> Galano &amp; Partners Law Firm
    </a>
  </div>
);
